import { fetchAuthSession } from "aws-amplify/auth";

export async function refreshUserSession() {
  await fetchAuthSession({ forceRefresh: true });
}
